<template>
  <v-flex xs12>
    <v-card>
      <v-toolbar
        light
        color="white"
        class="elevation-2"
      >
        <v-toolbar-title>Dashboard</v-toolbar-title>
      </v-toolbar>
      <DashboardList :items="itemsList" />
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DashboardList from './DashboardList.vue';

export default {
  name: 'dashboard-admin',
  components: {
    DashboardList,
  },
  computed: {
    ...mapGetters('dashboard-admin', [
      'itemsList',
    ]),
  },
  methods: {
    ...mapActions('dashboard-admin', [
      'getItemsList',
    ]),
    getList() {
      this.getItemsList();
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
